var map = {
	"./Auth/register.js": "aef0",
	"./CMS/register.js": "71bf",
	"./Campaigns/register.js": "353e",
	"./Customers/register.js": "4b46",
	"./Orders/register.js": "820d",
	"./Products/register.js": "d8da",
	"./Settings/register.js": "1421"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4332";